import React, { lazy, Suspense } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../webpack/chunkRetry';

const LoadableTools = lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "devtools" */
      '@hookform/devtools'
    ).then(module => ({ default: module.DevTool }))
  )
);

const HookFormDevtools: React.FC<any> = props => {
  const isMounted = useIsMounted();
  const enabled = useFlag('hookform_devtools');

  if (!isMounted || !enabled) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="HookFormDevtools">
      <Suspense fallback={null}>
        <LoadableTools {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
HookFormDevtools.displayName = 'HookFormDevtools';

export default HookFormDevtools;
